import { TableRow } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const InvoicesTableRow = styled(TableRow)<{
  $deleted?: boolean;
  $marked?: boolean;
  $highlighted?: boolean;
}>`
  ${({ $deleted }) =>
    $deleted &&
    `{
    text-decoration: line-through;
    background-color: ${COLORS.GRAY_1};
    }`}
  ${({ $highlighted }) =>
    $highlighted &&
    `{
    background-color: #c4dbff;
    &&.MuiTableRow-hover:not(.Mui-selected) {
      &:hover {
        background-color: #b0cfff;
      }
    }
    }`}
  ${({ $marked }) =>
    $marked &&
    `{
    background-color: ${COLORS.RED};
    &&.MuiTableRow-hover:not(.Mui-selected) {
      &:hover {
        background-color: ${COLORS.DARK_RED};
      }
    }
    }`}
`;
